import axios from 'axios'
import app from '@/main'
import tips from './tips'
import { iPath } from './i18n'
import store from '@/store'
import Vue from 'vue'

axios.defaults.withCredentials = true
// axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'
export class HttpMiddleware {
  constructor(fn) {
    const self = this
    function resolve(url, res) {
      const data = res.data
      !!self.fnComplete && self.fnComplete(res)
      if (
        data.error_code === 400001 ||
        data.error_code === 100000 ||
        data.error_code === 'E_1'
      ) {
        return
      }

      if (data.error_code) {
        const locale = ['en', 'id', 'it'].includes(store.state.locale)
        const langTips = tips[locale ? 'en' : store.state.locale]
        Vue.prototype.$message({
          message: langTips[data.error_code],
          type: 'error'
        })

        if (data.error_code === 100010) {
          app.$store.commit('LOGOUT')
          app.$router.push(iPath('/login'))
        }
      }
    }
    function reject(url, error) {
      console.error('request error: \n' + 'url: ' + url, error)
    }
    function abort(source) {
      self.source = source
    }
    return fn(resolve, reject, abort)
  }
  then(done) {
    this.fnComplete = done
    return this
  }
  abort() {
    const source = this.source
    source.cancel('API is aborted.')
    return this
  }
}

class Http {
  constructor() {
    this.request = function(opt) {
      return new HttpMiddleware((resolve, reject, abort) => {
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        if (!opt.url.match('http')) {
          opt.url = CONFIG.api_edu + opt.url
        }
        opt.headers = {}

        if (!opt.noToken) {
          if (localStorage.token) {
            opt.headers.Authorization = 'Bearer ' + localStorage.token
          }
          opt.headers['Authorization_Type'] = 3
        }

        axios
          .request({
            cancelToken: source.token,
            validateStatus: function(status) {
              return status >= 200 && status < 599 // default
            },
            ...opt
          })
          .then(res => {
            resolve(opt.url, res)
          })
          .catch(error => {
            if (error.toString().indexOf('timeout') > -1) {
              Vue.prototype.$message({
                type: 'error',
                message: 'Network timeout'
              })
            }
            reject(opt.url, error)
          })
        abort(source)
      })
    }
  }
  get(url, params, config) {
    return this.request({
      method: 'get',
      url: url,
      params: params,
      ...config
    })
  }
  post(url, data, config) {
    return this.request({
      method: 'post',
      url: url,
      data: data,
      ...config
    })
  }
  put(url, data, config) {
    return this.request({
      method: 'put',
      url: url,
      data: data,
      ...config
    })
  }
  patch(url, data, config) {
    return this.request({
      method: 'patch',
      url: url,
      data: data,
      ...config
    })
  }
  delete(url, params = {}, config) {
    return this.request({
      method: 'delete',
      url: url,
      params: params,
      ...config
    })
  }
}

export const API = new Http()
